import { WallpaperCategory } from '../../TransferCustomizationProvider/types';
import I18n from '@wetransfer/transfer/modules/i18n';
import { Wallpaper } from '@wetransfer/transfer/store/customWallpapers';

import { SURVEY_URL } from './constants';

export const getWallpaperThumbnail = (
  wallpaper: Wallpaper
): string | undefined => {
  return (
    wallpaper.srcSmall ||
    wallpaper.srcMedium ||
    wallpaper.srcLarge ||
    wallpaper.localFileSrc
  );
};

enum SurveyCustomPropertyName {
  subscription = 's',
  userId = 'u',
  country = 'c',
}

const getCustomPropertyName = (
  longName: keyof typeof SurveyCustomPropertyName
): SurveyCustomPropertyName | undefined => {
  switch (longName) {
    case 'subscription':
      return SurveyCustomPropertyName.subscription;
    case 'userId':
      return SurveyCustomPropertyName.userId;
    case 'country':
      return SurveyCustomPropertyName.country;
    default:
      return undefined;
  }
};

export const getSurveyUrl = (params: {
  subscription?: string;
  userId?: string;
  country?: string;
}): string => {
  const paramString = Object.keys(params)
    .map<string>((key: string) =>
      params[key as keyof typeof SurveyCustomPropertyName]
        ? `${getCustomPropertyName(
            key as keyof typeof SurveyCustomPropertyName
          )}=${params[key as keyof typeof SurveyCustomPropertyName]}`
        : ''
    )
    .filter(Boolean)
    .join('&');

  return `${SURVEY_URL}#${paramString}`;
};

export const getDescriptiveText = (wallpaper: Wallpaper): string => {
  return wallpaper.category === WallpaperCategory.CURATED
    ? I18n.t(`custom-wallpaper.curated_description.${wallpaper.descrId}`)
    : wallpaper.category === WallpaperCategory.CUSTOM
    ? I18n.t('custom-wallpaper.custom_description')
    : '';
};
